(function() {
    'use strict';

    angular
        .module('setupApp')
        .controller('PolicyRelationController', PolicyRelationController);

    PolicyRelationController.$inject = ['$scope', '$state', 'DataUtils', 'PolicyRelation','NgTableParams'];

    function PolicyRelationController ($scope, $state, DataUtils, PolicyRelation,NgTableParams) {
        var vm = this;
        
        vm.policyrelation = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	PolicyRelation.query(function(result) {
                vm.policyrelation = result;
                if(vm.policyrelation !=null && vm.policyrelation.length > 0){
                	var i;
                	for( i = 0; i < vm.policyrelation.length; i++){
                		if(vm.policyrelation[i].relationStatus == "1"){
                			vm.policyrelation[i].relationStatusA = true;
                		}else{
                			vm.policyrelation[i].relationStatusA = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.policyrelation
    				});
                }
            });
        }
    }
})();
